export function placeNameSlug(title: string) {
	return title
		.normalize('NFKD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')
		.replace(/^_+|_+$/g, '')
		.slice(0, 26)
		.replace(/_+$/g, '')
}

// Legacy notes may be messages rather than names. Only promote a note when it
// matches the name-derived handle (or the original free-claim placeholder).
export function placeDisplayName(handle: string, note?: string | null) {
	const slug = note ? placeNameSlug(note) : ''
	return note &&
		(/^place_[0-9a-f]{15}$/.test(handle) ||
			(slug &&
				(handle === slug ||
					(handle.startsWith(`${slug}_`) &&
						/^\d+$/.test(handle.slice(slug.length + 1))))))
		? note
		: handle
}
